import { z } from 'zod';

export const BatteryRemainingSchema = z.object({
    remaining: z.number(),
    id: z.int(),
    voltage: z.number()
});

export type BatteryRemainingData = z.infer<typeof BatteryRemainingSchema>;

export const BatteryRemainingListSchema = z.array(BatteryRemainingSchema);

export type BatteryRemainingListData = z.infer<typeof BatteryRemainingListSchema>;
